import { BaseMutations } from '@/store/base-mutations';
import MaterialsState from './state';
import { Materials } from '../types';

export default class MaterialsMutations extends BaseMutations<MaterialsState> {
  SET_NESTED_MATERIALS(materials: Materials.Material[]) {
    this.state.nested_materials = materials;
  }

  TOGGLE_MATERIALS_LOADING(value: boolean) {
    this.state.materials_loading = value;
  }

  SET_MATERIAL_URL(value: Materials.MarketingMaterialUrl | null) {
    this.state.material_url = value;
  }

  SET_MATERIAL(material: Materials.Material | null) {
    this.state.material = material;
  }

  SET_DOWNLOADED_BYTES(value: number) {
    this.state.downloaded_bytes = value;
  }

  SET_DOWNLOADED_FILE_NAME(value: string | null) {
    this.state.downloaded_file_name = value;
  }

  CLEAR_DOWNLOADED_URL() {
    if (this.state.downloaded_url) {
      URL.revokeObjectURL(this.state.downloaded_url);
    }
    this.state.downloaded_url = null;
  }

  CREATE_DOWNLOADED_URL(blob: Blob) {
    this.state.downloaded_url = URL.createObjectURL(blob);
  }

  SET_DOWNLOAD_LENGTH(value: number) {
    this.state.download_length = value;
  }

  TOGGLE_DOWNLOADING(value: boolean) {
    this.state.downloading = value;
  }

  TOGGLE_DOWNLOADING_FAILED(value: boolean) {
    this.state.downloading_failed = value;
  }

  CLEAR_DOWNLOAD() {
    this.state.downloading = false;
    this.state.downloading_failed = false;
    this.state.downloaded_file_name = null;
    this.state.downloaded_bytes = 0;
    this.state.download_length = 0;
  }

  CLEAR_MATERIALS() {
    this.state.material_url = null;
    this.state.material = null;
    this.state.nested_materials = [];
    this.state.materials_loading = false;
  }
}
